import { jsx as o } from "react/jsx-runtime";
import { NotFoundMessageType as t } from "./NotFoundMessage.utils.js";
import "@material-ui/core/Box";
import "@material-ui/core/Button";
import p from "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import e from "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import m from "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import "@propify-tenant-client/common";
const pr = ({ type: i }) => {
  let r;
  switch (i) {
    case t.UNIT:
      r = "Sorry, this property is no longer available. Please return to our search page and browse our available properties.";
      break;
    case t.SHOWINGS:
      r = "You don't have showings! Please visit our properties search page and schedule one for your next home.";
      break;
    case t.WAITING_LIST:
      r = "You don't have any units in your waiting list! Please visit our properties search page and find your next home.";
      break;
    default:
      r = "Not found";
  }
  return /* @__PURE__ */ o(e, { "data-testid": "nfm-container", maxWidth: "md", style: { paddingTop: "15px" }, children: /* @__PURE__ */ o(p, { children: /* @__PURE__ */ o(m, { "data-testid": "nfm-message", style: { textAlign: "center", padding: "15px" }, children: r }) }) });
};
export {
  pr as default
};
//# sourceMappingURL=NotFoundMessage.js.map
